import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject)
        return originalPush.call(this, location, onResolve, onReject)
    return originalPush.call(this, location).catch((err) => err)
}

Vue.use(VueRouter)

const routes = [{
        path: '/',
        name: 'home',
        meta: {
            title: '首页',
            isShowLeftArrow: false,
            isShowTitle: true
        },
        component: HomeView
    },
    {
        path: '/order-list',
        name: 'orderList',
        meta: {
            title: '订单列表',
            isShowLeftArrow: true,
            isShowTitle: true
        },
        component: () => import( /* webpackChunkName: "orderList" */ '../views/order/OrderList.vue')
    },
    {
        path: '/order-aftersale',
        name: 'orderAftersale',
        meta: {
            title: '商品售后',
            isShowLeftArrow: true,
            isShowTitle: true
        },
        component: () => import( /* webpackChunkName: "orderAftersale" */ '../views/order/OrderAftersale.vue')
    },
    {
        path: '/order-comment',
        name: 'orderComment',
        meta: {
            title: '商品评价',
            isShowLeftArrow: true,
            isShowTitle: true
        },
        component: () => import( /* webpackChunkName: "orderComment" */ '../views/order/OrderComment.vue')
    },
    {
        path: '/order-pay',
        name: 'orderPay',
        meta: {
            title: '账单详情',
            isShowLeftArrow: false,
            isShowTitle: false
        },
        component: () => import( /* webpackChunkName: "orderPay" */ '../views/order/OrderPay.vue')
    },
    {
        path: '/order-pay-result',
        name: 'orderPayResult',
        meta: {
            title: '账单详情',
            isShowLeftArrow: false,
            isShowTitle: false
        },
        component: () => import( /* webpackChunkName: "orderPayResult" */ '../views/order/OrderPayResult.vue')
    },
    {
        path: '/aftersale-record',
        name: 'aftersaleRecord',
        meta: {
            title: '售后记录',
            isShowLeftArrow: true,
            isShowTitle: true
        },
        component: () => import( /* webpackChunkName: "aftersaleRecord" */ '../views/order/AftersaleRecord.vue')
    },
    {
        path: '/comment-record',
        name: 'commentRecord',
        meta: {
            title: '评价记录',
            isShowLeftArrow: true,
            isShowTitle: true
        },
        component: () => import( /* webpackChunkName: "commentRecord" */ '../views/order/CommentRecord.vue')
    },
    {
        path: '/appreciate',
        name: 'appreciate',
        meta: {
            title: '赞赏排行榜',
            isShowLeftArrow: false,
            isShowTitle: true
        },
        component: () => import( /* webpackChunkName: "appreciate" */ '../views/appreciate/Index.vue')
    },
    {
        path: '/order-confirm',
        name: 'orderConfirm',
        meta: {
            title: '确认订单',
            isShowLeftArrow: true,
            isShowTitle: true
        },
        component: () => import( /* webpackChunkName: "orderConfirm" */ '../views/order/OrderConfirm.vue')
    },
    {
        path: '/order-detail',
        name: 'orderDetail',
        meta: {
            title: '订单详情',
            isShowLeftArrow: true,
            isShowTitle: true
        },
        component: () => import( /* webpackChunkName: "orderDetail" */ '../views/order/OrderDetail.vue')
    },
    {
        path: '/charge-detail',
        name: 'chargeDetail',
        meta: {
            title: '开始充电',
            isShowLeftArrow: true,
            isShowTitle: true
        },
        component: () => import( /* webpackChunkName: "chargeDetail" */ '../views/chargeStation/ChargeDetail.vue')
    },
    {
        path: '/charge-service-detail',
        name: 'chargeServiceDetail',
        meta: {
            title: '确认支付',
            isShowLeftArrow: true,
            isShowTitle: true
        },
        component: () => import( /* webpackChunkName: "chargeServiceDetail" */ '../views/chargeStation/ChargeServiceDetail.vue')
    },
    {
        path: '/goods-detail',
        name: 'goodsDetail',
        meta: {
            title: '商品详情',
            isShowLeftArrow: true,
            isShowTitle: true,
            // rightText: '分享'
        },
        component: () => import( /* webpackChunkName: "goodsDetail" */ '../views/goods/GoodDetail.vue')
    },
    {
        path: '/good-shop',
        name: 'goodShop',
        meta: {
            title: '店铺',
            isShowLeftArrow: true,
            isShowTitle: true
        },
        component: () => import( /* webpackChunkName: "goodShop" */ '../views/goods/GoodShop.vue')
    },
    {
        path: '/good-comment',
        name: 'goodComment',
        meta: {
            title: '评价',
            isShowLeftArrow: true,
            isShowTitle: true
        },
        component: () => import( /* webpackChunkName: "goodComment" */ '../views/goods/GoodComment.vue')
    },
    {
        path: '/shop-cart',
        name: 'shopCart',
        meta: {
            title: '购物车',
            isShowLeftArrow: true,
            isShowTitle: true
        },
        component: () => import( /* webpackChunkName: "shopCart" */ '../views/goods/ShopCart.vue')
    },
    {
        path: '/notice-announce',
        name: 'noticeAnnounce',
        meta: {
            title: '通知公告',
            isShowLeftArrow: false,
            isShowTitle: false
        },
        component: () => import( /* webpackChunkName: "noticeAnnounce" */ '../views/noticeAnnounce/Index.vue')
    },
    {
        path: '/notice-announce-detail',
        name: 'noticeAnnounceDetail',
        meta: {
            title: '通知公告详情',
            isShowLeftArrow: true,
            isShowTitle: false
        },
        component: () => import( /* webpackChunkName: "noticeAnnounceDetail" */ '../views/noticeAnnounce/Detail.vue')
    },
    {
        path: '/question-survey',
        name: 'questionSurvey',
        meta: {
            title: '问卷调查',
            isShowLeftArrow: false,
            isShowTitle: false
        },
        component: () => import( /* webpackChunkName: "questionSurvey" */ '../views/questionSurvey/Index.vue')
    },
    {
        path: '/question-survey-detail',
        name: 'questionSurveyDetail',
        meta: {
            title: '问卷调查详情',
            isShowLeftArrow: true,
            isShowTitle: false
        },
        component: () => import( /* webpackChunkName: "questionSurveyDetail" */ '../views/questionSurvey/Detail.vue')
    },
    {
        path: '/user-agreement',
        name: 'userAgreement',
        meta: {
            title: '用户协议',
            isShowLeftArrow: false,
            isShowTitle: false
        },
        component: () => import( /* webpackChunkName: "userAgreement" */ '../views/agreement/UserAgreement.vue')
    },
    {
        path: '/privacy-agreement',
        name: 'privacyAgreement',
        meta: {
            title: '隐私协议',
            isShowLeftArrow: false,
            isShowTitle: false
        },
        component: () => import( /* webpackChunkName: "privacyAgreement" */ '../views/agreement/PrivacyAgreement.vue')
    }
]

const router = new VueRouter({
    mode: 'hash',
    routes
})
router.beforeEach((to, from, next) => {
    if (to.meta.title) {
        document.title = to.meta.title;
    }
    next()
})
export default router